<input
  #uploadInput
  class="form-control"
  id="formFile"
  type="file"
  [accept]="mimeType"
  (change)="onFileSelected($event)"
  (click)="clearInput()"
  aria-labelledby="formFileHelp"
/>
<div id="formFileHelp" class="form-text">Select a document from your computer to upload.</div>
